import { FETCH_WIN_OPPORTUNITIES_FAILURE, FETCH_WIN_OPPORTUNITIES_REQUEST, FETCH_WIN_OPPORTUNITIES_SUCCESS } from "../../actions/opportunities/winOpportunitiesActions";

  const initialState = {
    winOpportunitesLoading: true,
    winOpportunitesData: [],
    winOpportunitesError: null,
  };
  
  const winOpportunitiesReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_WIN_OPPORTUNITIES_REQUEST:
        return { ...state, winOpportunitesLoading: true , payload: action.payload};
      case FETCH_WIN_OPPORTUNITIES_SUCCESS:
        return { ...state, winOpportunitesLoading: false, winOpportunitesData: action.payload };
      case FETCH_WIN_OPPORTUNITIES_FAILURE:
        return { ...state, winOpportunitesLoading: false, winOpportunitesError: action.payload };       
      default:
        return state;
    }
  };
  
  export default winOpportunitiesReducer;
  